
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["radio"]

  radioTargetConnected = (element) => {
    // Submit the form when a radio button is checked
    element.addEventListener("change", () => {
      this.element.requestSubmit();
    });
  }
}
